import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FormElement, FormSubmissionResponse } from '@uplift/types';
import { useFormDefinitionForSubmissionQuery, useFormSubmissionResultsQuery } from '@uplift/queries';


const useFormElementCellStyles = makeStyles()({
  root: {
    whiteSpace: 'nowrap',
  }
});

const FormElementCell: React.VFC<{
  responses: FormSubmissionResponse[];
  element: FormElement;
}> = ({ responses, element }) => {
  const { classes } = useFormElementCellStyles();
  const response = responses?.find(x => x.formElementId === element.formElementId);
  const answer = element?.formElementAnswers?.find(x => x.formElementAnswerId === response?.formElementAnswerId);

  return (
    <TableCell className={classes.root}>
      {(answer?.score !== null && answer?.score !== undefined) && <b>{answer.score} </b>}{answer?.answerText}
    </TableCell>
  );
};


export const useStyles = makeStyles()(theme => ({
  row: {
    paddingBottom: 0,
    paddingTop: 0,

    '&:nth-child(odd)': {
      backgroundColor: theme.palette.grey['100'],
    },

    '& > td': {
      borderBottom: 'unset',
    }
  },
}));


export type AssessmentReviewTableProps = {
  formSubmissionId: string;
};


export const AssessmentReviewTable: React.VFC<AssessmentReviewTableProps> = ({ formSubmissionId }) => {
  const { classes } = useStyles();
  const { data: formDefinition } = useFormDefinitionForSubmissionQuery(formSubmissionId);
  const { data: formSubmission } = useFormSubmissionResultsQuery(formSubmissionId, { suspense: true });
  const items = React.useMemo(() => formDefinition?.formElements.filter(x => !x.isFinal).filter(x => x.shortText) ?? [], [ formDefinition ]);

  if (!formDefinition || !formSubmission) {
    return (
      <TableRow>
        <TableCell colSpan={5}>
          Error loading data
        </TableCell>
      </TableRow>
    );
  }

  return (
    <Table>
      <TableBody>
        {items.map((e, eIdx) => (
          <TableRow key={`element-${e.formElementId}-${eIdx}`} className={classes.row}>
            <TableCell>{e.shortText}</TableCell>
            <FormElementCell responses={formSubmission.responses.responses} element={e} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
